import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { ClockIcon } from "../ui/icons";
import { MedalIcon, PlayIcon } from "lucide-react";

export default function CourseListItem({ course, onClick }) {
  return (
    <div
      className="bg-white border border-[#e3eaf3] rounded-2xl shadow-sm flex items-stretch p-0 overflow-hidden cursor-pointer hover:shadow-md transition h-[12rem]"
      onClick={() => onClick?.(course) || null}
      tabIndex={0}
      role="button"
      aria-label={`View details for ${course.title}`}
    >
      {/* Image area */}
      <div className="relative w-[400px] min-w-[200px] h-full bg-[#f3f3f3] flex items-center justify-center">
        <img
          src={course.image}
          alt={course.title || "Course image"}
          className="w-full h-full object-cover"
        />
      </div>
      {/* Info area */}
      <div className="flex-1 flex flex-col px-6 py-4 min-w-0">
        <div className="flex items-center justify-between mb-4">
          <div className="flex flex-col items-start justify-start gap-2">
            <div 
              className="text-md truncate text-[var(--secondary-font)]" 
              title={course.title}
            >
              {course.title}
            </div>
            <div className="flex gap-2 flex-wrap">
              {course.tags && course.tags.slice(0, 3).map((tag, idx) => (
                <Badge key={idx} variant="blue" className="px-4 py-1 rounded-full">
                  {tag}
                </Badge>
              ))}
              {course.tags && course.tags.length > 3 && (
                <Badge variant="gray" className="px-4 py-1 rounded-full">
                  +{course.tags.length - 3} more
                </Badge>
              )}
            </div>
          </div>
          <div className="flex flex-col items-end justify-end gap-2 text-sm">
            <div className="flex items-center gap-2">
              <div className="text-gray-500 ml-1">Minimum Pass Percentage:</div>
              <Badge variant="yellow" className="px-4 py-1 rounded-full">
                <MedalIcon className="w-5 h-5" />
                {course.passingScore}%
              </Badge>
            </div>
            <div className="flex items-center gap-2">
              <div className="text-gray-500 ml-1">Completion Time:</div>
              <Badge variant="gray" className="px-4 py-1 rounded-full">
                <ClockIcon className="w-5 h-5" />
                {course.courseDuration}h
              </Badge>
            </div>
          </div>
        </div>
        <div className="text-xs text-[#7a869a] mb-2 w-[60%] line-clamp-2" title={course.description}>{course.description}</div>
        <Button
          className="ml-auto text-sm w-fit h-fit px-4 py-2 bg-[var(--primary-font)] text-white rounded-full hover:bg-[var(--secondary-font)] transition-colors font-medium"
          onClick={(e) => { e.stopPropagation(); onClick?.(course); }}
          type="button"
        >
          View Details
          <PlayIcon className="w-5 h-5 fill-white" />
        </Button>
      </div>
    </div>
  );
}
